import { activeWaves } from "./waveList.js";
export const WAVE_INBOX_SECTION_LIMIT = 12;
export function dedupeWavesById(waves) {
    const seen = new Set();
    const out = [];
    for (const wave of waves) {
        if (seen.has(wave.waveId))
            continue;
        seen.add(wave.waveId);
        out.push(wave);
    }
    return out;
}
export function buildWaveInboxSections(input) {
    const limit = input.limit ?? WAVE_INBOX_SECTION_LIMIT;
    const pool = activeWaves(dedupeWavesById(input.pool));
    const byId = new Map(pool.map((wave) => [wave.waveId, wave]));
    const me = input.ownerSub.trim();
    const recentlyOpened = [...byId.keys()]
        .map((waveId) => ({ waveId, openedAt: input.lastOpenedEpochMs(waveId) ?? 0 }))
        .filter((row) => row.openedAt > 0)
        .sort((a, b) => b.openedAt - a.openedAt)
        .slice(0, limit)
        .map((row) => byId.get(row.waveId))
        .filter((wave) => Boolean(wave));
    const recentlyCreated = pool
        .filter((wave) => me.length > 0 && wave.ownerSub === me)
        .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
        .slice(0, limit);
    const recentlyShared = pool
        .filter((wave) => isSharedWave(wave, me))
        .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
        .slice(0, limit);
    return [
        { id: "recent-open", title: "Ultime aperte", waves: recentlyOpened },
        { id: "recent-created", title: "Ultime create", waves: recentlyCreated },
        { id: "recent-shared", title: "Ultime condivise", waves: recentlyShared },
    ];
}
function isSharedWave(wave, ownerSub) {
    if (!ownerSub || ownerSub === "anonymous")
        return false;
    const participants = wave.participants ?? [];
    if (wave.ownerSub === ownerSub) {
        return participants.some((p) => p.sub !== ownerSub);
    }
    return participants.some((p) => p.sub === ownerSub);
}
